import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import filterFactory from "react-bootstrap-table2-filter";

import {
  sortNumeric,
  selectFormat,
  TableContentCell,
  getMetricForColumn,
  Error,
} from "./../../Utils/Utils.js";

import Heading from "./../../Elements/Heading";

class YouTubeReview extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { networks: ["all"] };
  }

  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data) {
    const { cells, title } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "title",
        text: "Title",
        headerClasses: "sticky-column",
        style: { width: "320px", minWidth: "320px", textAlign: "left" },
        headerAlign: "left",
        classes: "sticky-column",
        formatter: TableContentCell,
        csvFormatter: (cell, row) => row && (row.title || row.tweet_text || ""),
        sort: true,
      },
      {
        dataField: "video_id",
        text: "ID",
        style: { width: "90px", minWidth: "90px" },
        sort: true,
      },
      {
        dataField: "views",
        text: "Views",
        style: { width: "60px", minWidth: "60px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      // {
      //   dataField: "viewer_percentage",
      //   text: "Viewer %",
      //   style: { width: "90px", minWidth: "90px" },
      //   formatter: getMetricForColumn,
      //   formatExtraData: { type: "percentage" },
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0.0"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },
      // {
      //   dataField: "subscribers_gained",
      //   text: "Subscribers Gained",
      //   style: { width: "90px", minWidth: "90px" },
      //   formatter: getMetricForColumn,
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0,0"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },
      // {
      //   dataField: "subscribers_lost",
      //   text: "Subscribers Lost",
      //   style: { width: "100px", minWidth: "100px" },
      //   formatter: getMetricForColumn,
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0,0"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },

      // {
      //   dataField: "annotation_ctr",
      //   text: "Annotation CTR",
      //   style: { width: "90px", minWidth: "90px" },
      //   formatter: getMetricForColumn,
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0,0"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },
      // {
      //   dataField: "annotation_cl_total",
      //   text: "Annotation CL",
      //   style: { width: "90px", minWidth: "90px" },
      //   formatter: getMetricForColumn,
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0,0"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },
      {
        dataField: "watch_time_minutes",
        text: "Watch Time",
        style: { width: "90px", minWidth: "90px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "minutes", format: "0,000" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,000"),
        sort: true,
        sortFunc: sortNumeric,
      },
      // {
      //   dataField: "average_view_duration_seconds",
      //   text: "Avg Duration",
      //   style: { width: "90px", minWidth: "90px" },
      //   formatter: getMetricForColumn,
      //   formatExtraData: { type: "sec" },
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0,0"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },
      {
        dataField: "comments",
        text: "Comments",
        style: { width: "60px", minWidth: "60px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "dislikes",
        text: "Dislikes",
        style: { width: "60px", minWidth: "60px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },

      // {
      //   dataField: "estimated_minutes_watched",
      //   text: "Estimated Minutes Watched",
      //   style: { width: "120px", minWidth: "120px" },
      //   formatter: getMetricForColumn,
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0,0"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },

      // {
      //   dataField: "estimated_revenue",
      //   text: "Estimated Revenue",
      //   style: { width: "120px", minWidth: "120px" },
      //   formatter: getMetricForColumn,
      //   formatExtraData: { type: "percentage" },
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0.000%"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },

      {
        dataField: "likes",
        text: "Likes",
        style: { width: "60px", minWidth: "60px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "shares",
        text: "Shares",
        style: { width: "60px", minWidth: "60px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const defaultSorted = [
      {
        dataField: "views",
        order: "desc",
      },
    ];

    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";

    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            filter={filterFactory()}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.data.hasData === false) {
      return <Error minHeight={560} />;
    }

    return (
      <>
        <Heading size={6} key={"heading"}>
          This table shows the top 10 videos for the SYFY WIRE channel on{" "}
          <a href="https://youtube.com" className="text-orange">
            YouTube
          </a>{" "}
          for the day of May 15, 2020.
        </Heading>

        {this.renderTable(data.data)}
      </>
    );
  }
}

export default YouTubeReview;
